// Client-side image compression for "Data saver" mode.
// Downscales to a max dimension and re-encodes as JPEG at reduced quality.
export async function compressImage(file, { maxDim = 1280, quality = 0.6 } = {}) {
  if (!file.type.startsWith("image/") || file.type === "image/gif") return file;
  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    width = Math.round(width * scale);
    height = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file; // don't upsize
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
}

export const dataSaverOn = () => localStorage.getItem("rc_data_saver") !== "0"; // default ON

// Capture a small JPEG poster (first frame) from a video File — for thumbnail-first delivery.
export async function videoPoster(file) {
  return new Promise((resolve) => {
    try {
      const v = document.createElement("video");
      v.preload = "metadata"; v.muted = true; v.playsInline = true;
      const objUrl = URL.createObjectURL(file);
      v.src = objUrl;
      const cleanup = () => { try { URL.revokeObjectURL(objUrl); } catch {} };
      v.onloadeddata = () => { try { v.currentTime = Math.min(0.1, (v.duration || 1) / 2); } catch (e) {} };
      v.onseeked = async () => {
        try {
          const vw = v.videoWidth || 640, vh = v.videoHeight || 640;
          const scale = Math.min(1, 640 / Math.max(vw, vh));
          const canvas = document.createElement("canvas");
          canvas.width = Math.max(1, Math.round(vw * scale));
          canvas.height = Math.max(1, Math.round(vh * scale));
          canvas.getContext("2d").drawImage(v, 0, 0, canvas.width, canvas.height);
          const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.6));
          cleanup();
          resolve(blob ? new File([blob], "poster.jpg", { type: "image/jpeg" }) : null);
        } catch { cleanup(); resolve(null); }
      };
      v.onerror = () => { cleanup(); resolve(null); };
    } catch { resolve(null); }
  });
}
